import React, { useState, useEffect } from 'react';
import CreateSeamlessTiles from './components/CreateTilesContainer';
import { useDropzone } from 'react-dropzone';

import './App.css'
import WebWorker from './WebWorker';
import worker from './worker';

const imageInstance = new Image();

function App() {
  const processImageWorker = new WebWorker(worker);

  const [imageFile, setImageFile] = useState(null);
  const [imageURL, setImageURL] = useState('ai.png');
  const [tileSize, setTileSize] = useState(350);
  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/webp': ['.webp']
    },
    // multiple:false,
    noClick: true,
    // maxFiles: 1, // Allow only one file
    onDrop: (newFiles) => {
      const file = newFiles[0];
      console.log(newFiles)
      setImageFile(file)
      const fileURL = URL.createObjectURL(file)
      setImageURL(fileURL)

      const reader = new FileReader();

      reader.onload = (event) => {

        imageInstance.onload = () => {
          const width = imageInstance.width;
          const height = imageInstance.height;
          console.log("Image dimensions:", width, height);
        };
        imageInstance.src = event.target.result;
      };

      reader.readAsDataURL(file);
    },
    onError: (err) => console.log(err)
  });

  const exportCheck = () => {
    
    if (!imageFile) { return; }
    if (imageInstance.naturalWidth == 0 || imageInstance.naturalHeight == 0) { return; }

    let repeatTile = { x: 1, y: 1 };
    const ratio = (tileSize) / imageInstance.naturalWidth;
    //produce a squarish output which ever is bigger
    if (window.innerWidth >= window.innerHeight) {
      //lanscape or square viewport
      repeatTile.x = Math.ceil(window.innerWidth / (tileSize));
      repeatTile.y = Math.ceil(window.innerWidth / (imageInstance.naturalHeight * ratio));
    }
    else {
      //portrait viewport
      repeatTile.x = Math.ceil(window.innerHeight / (tileSize));
      repeatTile.y = Math.ceil(window.innerHeight / (imageInstance.naturalHeight * ratio));
    }
    return repeatTile;
  }


  const handleDownload = () => {
    console.log("download button clicked");

    const ok = typeof OffscreenCanvasRenderingContext2D === "function";
    if (!ok) {
      alert("yet to be supported in this browser")
      return;
    }

    const repeatTile = exportCheck();
    if (!repeatTile) { return; }
    const limit = 10000; //=> Set limit here
    //const limit = window.innerWidth;

    processImageWorker.postMessage({ imageFile, repeatTile, limit });

    processImageWorker.addEventListener('message', (event) => {
      console.log(event.data)
      const blob = event.data;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = 'seamless-pattern.png';
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    });

  };

  // Revoke the object URL whenever you are done with it
  useEffect(() => {
    return () => imageURL && URL.revokeObjectURL(imageURL);
  }, [imageURL]);

  useEffect(() => {
    return () => {
      processImageWorker.terminate()
    }
  }, [])


  return (
    <main {...getRootProps()} className="h-screen bg-cover bg-center" style={{ backgroundImage: `url(${imageURL})`, backgroundSize: `${tileSize}px`, transition: 'background-size 0.1s' }}>

      <CreateSeamlessTiles handleDownload={handleDownload} setTileSize={setTileSize} imageFile={imageFile} open={open} />


      <input
        type="file"
        className="!hidden"
        {...getInputProps()}
      />
    </main>
  );
}

export default App;

